import {Alert} from 'react-bootstrap'
import {connect} from 'react-redux'
import {reduxForm, Field, formValueSelector} from 'redux-form' // change
import styles from './style.css'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import SettingFieldWithIcon from 'components/Fields/ReduxForm/SettingFieldWithIcon'
import LabelSection from 'components/sections/LabelSection'
import ActionBarDetailWrapper from 'components/wrappers/pages/ActionBarDetailWrapper'
import * as actTax from 'actions/library/tax'
import * as mpLibraryTax from 'mixpanel/library/tax'

import IcWarnX1 from 'assets/images/warning-icon.png'
import IcWarnX2 from 'assets/images/warning-icon@2x.png'
import _groupBy from 'lodash/groupBy'
import _values from 'lodash/values'
import _keyBy from 'lodash/keyBy'

const validate = (values) => {
  const errors = {}
  if ((!values.name) || (values.name.trim() === '')) {
    errors.name = 'Please enter a value'
  }
  if (!values.amount) {
    errors.amount = 'Please enter a value'
  } else if (values.amount < 1) {
    errors.amount = 'Please enter a value greater than or equal 1'
  } else if (values.amount > 100) {
    errors.amount = 'Please input tax less 100%'
  }
  return errors
}

class TaxForm extends React.Component {
  renderCategoryItemsList () {
    let categoryCount = (<tr><td className={styles['no-items']}>No Items Assigned to this tax</td></tr>)
    let { taxDetail, categories } = this.props
    if (taxDetail !== null && Array.isArray(taxDetail.items) === true && taxDetail.items.length > 0) {
      let groupedObj = _groupBy(taxDetail.items, 'category_id')
      let groupedArr = _values(groupedObj)
      let categoriesMap = _keyBy(categories, 'id')
      categoryCount = groupedArr.map((item) => {
        const categoryId = item[0].category_id
        const categoryName = categoriesMap[categoryId] === undefined ? categoryId : categoriesMap[categoryId].name
        return (
          <tr>
            <td className={styles.name}>{categoryName}</td>
            <td className={styles.amount}><a href='#' onClick={(e) => this._onClickTaxAssignToItem(e, categoryId)}>{item.length} items applied</a></td>
          </tr>
        )
      })
    }
    return (
      <table className={styles['table-content']}>
        <tbody>
          {categoryCount}
        </tbody>
      </table>
    )
  }

  renderEnableTax () {
    if (this.props.setting.enable_tax === false) {
      return (
        <Alert bsStyle='warning'>
          <img src={IcWarnX1}
            srcSet={IcWarnX2}
            className={styles['Warning-Icon']} /> Your Tax Setting is disabled. Tax will not be applied to the transactions.
        </Alert>
      )
    }
  }

  render () {
    let {handleSubmit, isSubmittingForm} = this.props
    return (
      <form className={styles.wrapper}>
        <div className={styles['field-wrapper']}>
          <div className='row mb-20px'>
            <div className='col-sm-12'>
              <LabelSection title='Tax Information' />
              <div className='col-sm-6 col-md-4 no-padding'>
                <Field
                  inputClassName=''
                  component={SettingField}
                  name='name'
                  className='form-control'
                  placeholder='Name'
                />
              </div>
              <div className='col-sm-6 col-md-4'>
                <Field
                  component={SettingFieldWithIcon}
                  name='amount'
                  icon='%'
                  className='form-control'
                  placeholder='Amount'
                  positiveNumberOnly
                  maxFractionDigits={3}
                  />
              </div>

              <div className='col-xs-12 no-padding'>
                <label className={`${styles['custom-amount-cb']}`}>
                  <Field
                    name='custom_amount_flag'
                    component='input'
                    type='checkbox'
                    className='form-check-input'
                  />{' '}
                  Applied to Custom Amount
                </label>
              </div>

            </div>
          </div>
          {this.renderEnableTax()}
          <div className='row mb-20px'>
            <div className='col-sm-12'>
              <LabelSection title='Assign To Selected Items' />
              <div className={styles.wrapper}>
                <div className={styles['table-content-wrapper']}>
                  <button onClick={(e) => this._onClickTaxAssignToItem(e, '')}
                    className={`btn btn-primary btn-block ${styles['btn-assign']}`}
                  >Assign To Items</button>
                  {this.renderCategoryItemsList()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ActionBarDetailWrapper>
          <span className='pull-left'>
            {this.props.tax.id && <button className='btn btn-danger'
              onClick={this._onClickDelete}
              type='button'
              disabled={isSubmittingForm}>
              <i className='fa fa-trash' />
            </button>}
          </span>
          <span className='pull-right'>
            <button
              type='button'
              className={`btn btn-default ${styles['btn-save']}`}
              onClick={this._onClickCancel}
              disabled={isSubmittingForm}>
              Cancel
            </button>
            { (!this.props.tax.id) &&
              this.props.outlets.length > 1 &&
              <button
                type='button'
                className={`btn btn-primary mr-10px`}
                onClick={handleSubmit(this._onSubmitToAllOutlet)}
                disabled={isSubmittingForm}>
                Save to All Outlets
              </button>
            }
            <button
              className={`btn btn-primary ${styles['btn-save']}`}
              onClick={handleSubmit(this._onSubmit)}
              type='button'
              disabled={isSubmittingForm}>
              Save
            </button>
          </span>
        </ActionBarDetailWrapper>
      </form>
    )
  }

  _onClickTaxAssignToItem = (e, categoryId) => {
    e.stopPropagation()
    e.preventDefault()
    const {dispatch, outletIds} = this.props
    if (!this.props.tax.id) {
      mpLibraryTax.libraryTaxCreateAssignItemStart(outletIds[0])
    } else {
      mpLibraryTax.libraryTaxEditAssignItemStart(outletIds[0])
    }
    dispatch(actTax.onClickTaxAssignToItem(this.props, categoryId)) // tax
  }

/* TODELETE
  _onChangeAmount = (event, nextVal, prevVal) => {
    if (!isNaN(nextVal)) {
      this.props.dispatch(change('taxForm', 'amount', nextVal))
    }
  }
*/

  _onClickCancel = (event) => {
    this.props.dispatch(actTax.onClickCancel())
    event.preventDefault()
    event.stopPropagation()
  }

  _onClickDelete = (event) => {
    const {dispatch, taxDetail} = this.props
    dispatch(actTax.deleteTaxRequest(taxDetail))
    event.preventDefault()
    event.stopPropagation()
  }

  _onSubmitToAllOutlet = (values) => {
    this.props.onSubmit({...values, action: 'saveToAllOutlet'})
  }

  _onSubmit = (values) => {
    this.props.onSubmit({...values, action: 'save'})
  }
}

const selector = formValueSelector('tax')

const mapForm = {
  form: 'tax',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

function mapStateToProps (state) {
  const {taxes, taxDetail, outlets, isSubmittingForm, categories, setting} = state.library.tax

  let outletIds = []
  if (outlets.length) {
    outletIds.push(outlets[0].id)
  }
  if (state.form.search.values !== undefined) {
    outletIds = state.form.search.values.outletIds
  }

  return {
    taxes,
    taxDetail,
    outlets,
    tax: {id: selector(state, 'id')},
    data: {
      form: state.form
    },
    isSubmittingForm,
    categories,
    setting,
    outletIds
  }
}

export default connect(mapStateToProps)(reduxForm(mapForm)(TaxForm))



// WEBPACK FOOTER //
// ./app/pages/Library/Tax/TaxDetail/TaxForm.js